/**
 * Created by Alex Aguilar on 5/12/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir.directiveCommon', [])
        .directive('loader', ['$rootScope', loader])
        .directive('mask', [mask])
        .directive('datepicker', [datepicker])
        .directive('datepickerBtn', [datepickerBtn])
        .directive('elementModelValue', ['$timeout', elementModelValue])
        .directive('validNumberLength', [validNumberLength])
        .directive('timePicker', [timePicker])
        .directive('timePickerValidate', [timePickerValidate])
        .directive('customButtonDatePicker', [customButtonDatePicker])
        .directive('customResetMsg', ['$timeout', customResetMsg])
        .directive('autoBlurElement', ['$timeout', autoBlurElement]);

    function loader(){
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attributes){
            scope.$on("loader_show", function () {
                return element.show();
            });
            return scope.$on("loader_hide", function () {
                return element.hide();
            });
        }
    }

    function elementModelValue($timeout){
        var directive = {
            restrict: 'AC',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function removeClassSuccess(element){
            $timeout(function () {
                var eleJQ = $(element).closest('.form-group');
                eleJQ.removeClass('has-success');
            }, 500);
        }

        function linkFunc(scope, element, attributes, ngModel){
            var eleValue = attributes.value;
            ngModel.$setViewValue(eleValue);
            ngModel.$render();
            removeClassSuccess(element);
        }
    }

    function mask(){
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attributes){
            if (attributes.mask)
                element.mask(attributes.mask/*, { placeholder: attributes.maskPlaceholder }*/);
        }
    }

    function datepicker(){
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attributes, ngModel){
            var updateModel = function (dateText) {
                scope.$apply(function () {
                    ngModel.$setViewValue(dateText);
                });
            };

            $.datepicker.setDefaults($.datepicker.regional["es"]);

            element.datepicker({
                dateFormat: "dd/mm/yy",
                numberOfMonths: 2,
                'onSelect': onSelect
            });

            function onSelect(date, dateObject){
                updateModel(date);
            }
        }
    }

    function datepickerBtn(){
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attributes){
            var eleJQ = $("#" + attributes.target)
            element.on('click', function(){
                eleJQ.datepicker("show");
            });
        }
    }

    function validNumberLength(){
        var directive = {
            restrict: 'AC',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
            element.on('keyup', function(){
                var value = element.val()+"";
                if (parseInt(element.val())>=parseInt(attrs.max)){
                    var max = attrs.max+"";
                    element.val(value.substring(0,(max.length-1)));
                }
            });
        }
    }

    function timePicker(){
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attributes, ngModel){
            element.on('blur', function(){
                var eleJQ = $(this),
                    splitValue = (eleJQ.val()).split(":"),
                    valueHour = (splitValue[0]).replace(/[_]/g, ""),
                    valueMinutes = (splitValue[1]).replace(/[_]/g, "");

                if(valueHour > 23){
                    valueHour = "23";
                }

                if(valueMinutes > 59){
                    valueMinutes = "59";
                }

                if(valueHour == ""){
                    valueHour = "00";
                }

                if(valueMinutes == ""){
                    valueMinutes = "00";
                }

                if(valueHour.length == 1 && valueHour.charAt(0) < 10){
                    valueHour = "00";
                }

                if(valueMinutes.length == 1 && valueMinutes.charAt(0) < 10){
                    valueMinutes = "00";
                }

                var valueTime = valueHour + ":" + valueMinutes;

                eleJQ.val(valueTime);
                ngModel.$setViewValue(valueTime);
                ngModel.$render();
            });
        }
    }

    function timePickerValidate(){
        var directive = {
            restrict: 'AC',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
            element.on('blur', function(){
                var targetTime = $('#' + attrs.targetTime),
                    targetTimeValue = targetTime.val(),
                    timeValue = $(this).val(),
                    typeValidate = attrs.typeValidate;

                if (!ngModel || !timeValue){
                    ngModel.$setValidity(typeValidate, true);
                    return;
                }

                var res = compareTime(targetTimeValue, timeValue);

                if(res){
                    ngModel.$setValidity(typeValidate, false);
                }else {
                    ngModel.$setValidity(typeValidate, true);
                }
            });

        }

        function compareTime(timeOne, timeTwo){
            var timeOneSplit = timeOne.split(':'),
                timeTwoSplit = timeTwo.split(':'),
                dateOne = new Date(),
                dateTwo = new Date();

            dateOne.setHours(timeOneSplit[0]);
            dateOne.setMinutes(timeOneSplit[1]);
            dateOne.setSeconds(timeOneSplit[2]);
            dateTwo.setHours(timeTwoSplit[0]);
            dateTwo.setMinutes(timeTwoSplit[1]);
            dateTwo.setSeconds(timeTwoSplit[2]);

            var res = false;

            if(dateOne.valueOf() === dateTwo.valueOf()){
                res = true;
            }else if(dateTwo.valueOf() < dateOne.valueOf()){
                res = true;
            }
            return res;
        }
    }

    function customButtonDatePicker(){
        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, $element, attrs) {
            $element.on('click',function(){
                var $input = $(this).parent().find('input');
                if($input.is(':focus')){
                    $input.trigger('blur');
                } else {
                    $input.trigger('focus');
                }
            });

        }
    }

    function customResetMsg($timeout){
        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, $element, attrs) {
            $timeout(function(){
                var eleJQ = $element.closest(".form-group"),
                    eleHelpBlock = eleJQ.find(".help-block");
                eleJQ.removeClass("has-error");
                eleHelpBlock.remove();
            }, 200);
        }
    }

    function autoBlurElement($timeout){
        var directive = {
            restrict: 'AC',
            scope : {
                trigger : '@blur'
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, $element, attrs) {

            scope.$watch('trigger', function(value) {
                if (value === "true") {
                    $timeout(function() {
                        $element[0].blur();
                    });
                }
            });
        }
    }

})();
